<template>
  <table-paginator :data="users" @pagechange="pagechange($event)">
    <div class="row" v-for="user in users.data" :key="user.id">
      <div :class="['card w-100 mb-2 card-selectable']" @click="toggleUser(user)">
        <div class="card-body">
          <div class="col-md-12">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="mr-3">
                  <avatar
                    inline
                    color="#fff"
                    :size="40"
                    :username="user.name"
                    :initials="user.name.slice(0, 1)"
                  ></avatar>
                </div>
                <div>
                  {{user.name}}
                  <br />
                  <small class="text-muted">{{ user.email}}</small>
                </div>
              </div>
              <div>
                <i class="fas fa-lg fa-check text-success" v-if="isUserSelected(user)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </table-paginator>
</template>

<script>

import Form from "./../../mixins/Form.js";
import Filters from "./../../mixins/Filters.js";
import Avatar from "vue-avatar";
import TablePaginator from "./../sections/TablePaginator.vue";

export default {

  components: {
    Avatar,
    TablePaginator
  },

  props : {
    value : {},
    users : {}
  },

  created() {
    this.selectedUsersId = this.value
  },

  data: function() {
    return {
      selectedUsersId : []
    }
  },

  methods : {
    isUserSelected(user) {
      return (this.selectedUsersId.includes(user.id))
    },

    toggleUser(user) {
      if (this.selectedUsersId.includes(user.id)) {
        this.selectedUsersId.splice(this.selectedUsersId.indexOf(user.id), 1)
      } else {
        //this.selectedUsers[user.id] = user
        this.selectedUsersId.push(user.id)
        this.$emit('userSelected', user)
      }

      this.$emit('input', this.selectedUsersId)
    },

    pagechange(page) {
      this.$emit('pagechange', page)
    }

  }

  



  
};
</script>

<style>
</style>